export const fieldValidation = {
  required: '{{fieldName}} 是必須的',
  pattern: '{{fieldName}} is invalid',
  maxLength: '{{fieldName}} 字數上限為 {{value}}',
};
